"use client";

import React from "react";
import { ArrowRight, CircleCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurServices() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const services = ["Geotechnical Testing", "Site Investigation", "Soil Analysis", "Probe Testing / Structural Probing", "Foundation Evaluation"];
  return <section id="our-services" ref={ref} className="bg-background text-foreground relative w-full overflow-hidden border-t border-border">
      <div className="grid grid-cols-1 lg:grid-cols-5 min-h-[700px]">
        {}
        <div className="lg:col-span-3 flex flex-col justify-center px-6 py-20 lg:px-16 xl:px-24">
          <div className={`transition-all duration-700 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <div className="flex items-center gap-4 mb-6">
              <Separator className="w-12 bg-primary h-[2px]" />
              <span className="text-primary font-bold tracking-widest uppercase text-sm">
                What We Do
              </span>
            </div>

            <h2 className="text-4xl md:text-5xl font-bold uppercase tracking-tight text-[#362242] mb-8 font-sans">
              Our Services
            </h2>

            <div className="space-y-6 text-lg text-muted-foreground font-sans max-w-2xl">
              <p>
                At QST Geotechnical, we provide precision-driven engineering solutions tailored to the unique demands of your project. Our team combines advanced technology with deep industry expertise to deliver accurate data and actionable insights.
              </p>
              <p>From initial site investigation to final foundation evaluation, we ensure stability and compliance at every stage of construction. We don't just test soil; we build the certainty you need to move forward.&nbsp;</p>
            </div>

            <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-4">
              {services.map((service, i) => <div key={i} data-index={i} className="flex items-center gap-3 group">
                  <CircleCheck className="w-5 h-5 text-primary shrink-0 group-hover:scale-110 transition-transform duration-300" />
                  <span className="text-foreground font-medium">{service}</span>
                </div>)}
            </div>

            <div className="mt-12 pt-8 border-t border-border/50">
              <Button asChild size="lg" className="rounded-full px-8 h-14 text-base bg-primary hover:bg-primary/90 text-white shadow-lg hover:shadow-xl transition-all duration-300">
                <Link to="/ServicesPage">
                  Explore All Services
                  <ArrowRight className="ml-2 w-5 h-5" />
                </Link>
              </Button>
            </div>
          </div>
        </div>

        {}
        <div className="lg:col-span-2 relative h-full min-h-[400px] lg:min-h-full bg-muted">
          <div className="absolute inset-0 bg-primary/10 z-10 mix-blend-multiply pointer-events-none" />
          <img src="https://fluent-gnu.10web.cloud/wp-content/uploads/2026/02/IMG_2941-scaled.jpg" alt="Heavy excavator machinery detail showing mechanical precision" className="absolute inset-0 w-full h-full object-cover grayscale contrast-125" />
          
          {}
          <div className="absolute top-0 left-0 w-full h-full pointer-events-none z-20">
            <div className="absolute top-10 left-10 w-20 h-20 border-l-2 border-t-2 border-white/30" />
            <div className="absolute bottom-10 right-10 w-20 h-20 border-r-2 border-b-2 border-white/30" />
          </div>
        </div>
      </div>
    </section>;
}